import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import NorLocale from 'date-fns/locale/nb';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  MenuItem, InputLabel,
  Select, OutlinedInput,
  Typography,
  Button, TextField, Tooltip,
} from '@material-ui/core';

class EditUserDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      role: props.user.role,
      represents: props.user.represents,
      note: props.user.note,
      fromDate: new Date(props.user.from),
      toDate: props.user.to ? new Date(props.user.to) : null,
    };
  }

  handleChange = (event) => {
    this.setState({ role: event.target.value });
  }

  render() {
    const {
      open, classes, user, handleClose, handleSave, removeMember,
    } = this.props;
    const {
      role, represents, fromDate, toDate, note,
    } = this.state;

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={NorLocale}>
        <Dialog open={open}>
          <DialogTitle disableTypography>
            <Tooltip title="Bruker vil lagres i historikken" aria-label="Fjern_bruker" placement="right" classes={{ tooltip: classes.tooltip }}>
              <Typography variant="subtitle2" display="inline" component="p" className={classes.deactivateText} onClick={removeMember}>
                Fjern bruker fra utvalget
              </Typography>
            </Tooltip>
            <Typography component="h2" variant="h6">{`Rediger ${user.label || (`${user.givenName} ${user.familyName}`) || user.label}`}</Typography>
          </DialogTitle>
          <DialogContent>
            <FormControl variant="outlined" className={classes.role}>
              <InputLabel className={classes.label} required>Stilling</InputLabel>
              <Select
                variant="outlined"
                value={role}
                onChange={this.handleChange}
                displayEmpty
                className={classes.select}
                input={<OutlinedInput labelWidth={56} name="par" />}
              >
                <MenuItem value="Ordfører">Ordfører</MenuItem>
                <MenuItem value="Varaordfører">Varaordfører</MenuItem>
                <MenuItem value="Leder">Leder</MenuItem>
                <MenuItem value="Nestleder">Nestleder</MenuItem>
                <MenuItem value="Byrådsleder">Byrådsleder</MenuItem>
                <MenuItem value="Byrådsnestleder">Byrådsnestleder</MenuItem>
                <MenuItem value="Byråd">Byråd</MenuItem>
                <MenuItem value="Byrådssekretær">Byrådssekretær</MenuItem>
                <MenuItem value="Medlem">Medlem</MenuItem>
                <MenuItem value="Varamedlem">Varamedlem</MenuItem>
                <MenuItem value="Sekretær">Sekretær</MenuItem>
                <MenuItem value="Observatør">Observatør</MenuItem>
              </Select>
            </FormControl>
            <TextField
              variant="outlined"
              label="Representerer (valgfritt)"
              onChange={e => this.setState({ represents: e.target.value })}
              fullWidth
              defaultValue={represents}
            />
            <TextField
              variant="outlined"
              label="Merknad (valgfritt)"
              onChange={e => this.setState({ note: e.target.value })}
              fullWidth
              defaultValue={note}
              className={classes.mt}
            />
            <KeyboardDatePicker
              className={clsx(classes.datepicker, classes.mr)}
              value={fromDate}
              placeholder="dd.mm.yyyy"
              onChange={val => this.setState({ fromDate: val })}
              format="dd.MM.yyyy"
              inputVariant="outlined"
              required
              label="Fra"
            />
            <KeyboardDatePicker
              className={classes.datepicker}
              value={toDate}
              placeholder="dd.mm.yyyy"
              onChange={val => this.setState({ toDate: val })}
              format="dd.MM.yyyy"
              inputVariant="outlined"
              required
              label="Til"
            />
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleClose}>
              Avbryt
            </Button>
            <Button variant="contained" color="primary" disabled={role === ''} onClick={() => handleSave(role, represents, note, fromDate, toDate)}>
              Endre
            </Button>
          </DialogActions>
        </Dialog>
      </MuiPickersUtilsProvider>
    );
  }
}

const styles = theme => ({
  deactivateText: {
    color: theme.palette.error.main,
    textDecoration: 'underline',
    marginBottom: '1rem',
    cursor: 'pointer',
  },
  role: {
    marginTop: '0.5rem',
    marginBottom: '1rem',
    width: '100%',
  },
  datepicker: {
    marginTop: '1.5rem',
    width: '12rem',
  },
  mr: {
    marginRight: '1rem',
  },
  tooltip: {
    fontSize: '0.75rem',
  },
  mt: {
    marginTop: '1rem',
  },
});

EditUserDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  classes: PropTypes.any.isRequired,
  user: PropTypes.any,
  handleClose: PropTypes.func,
  handleSave: PropTypes.func,
  removeMember: PropTypes.func,
};

EditUserDialog.defaultProps = {
  user: {},
  handleClose: () => {},
  handleSave: () => {},
  removeMember: () => {},
};

export default withStyles(styles)(EditUserDialog);
